exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".month-detail-modal[data-v-f916e7dc] .ant-modal-title {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n.month-detail-modal[data-v-f916e7dc] .ant-modal-body {\n  min-height: 590px;\n  padding: 10px 24px;\n}\n.month-detail-modal[data-v-f916e7dc] .ant-modal-footer {\n  padding-top: 0;\n  padding-bottom: 16px;\n  border-top: none;\n}\n", ""]);

// exports
